// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // ***************************************************************************************
  // ***************************** Alfredditto PRODUCCION *****************************
  // urlBase: 'https://api-col.smallshi.com/',
  // urlReservas: '',
  // options: {
  //   isHotel:true,
  //   taskUrl:'https://api-alfred-itto-prod.smallshi.com/',
  //   inspector_id:1914,
  //   administrador:1925,
  //   delivery:false,
  //   numeroHabitacion:true,
  //   tiempo:30
  // }

  // ***************************************************************************************
  // ***************************** Alfredditto TEST *****************************
  // urlBase: 'https://api-test.smallshi.com/',
  //  urlReservas: '',
  // options: {
  //   isHotel:true,
  //   taskUrl:'https://test-api-alfred-itto.smallshi.com/',
  //   inspector_id:1914,
  //   administrador:1925,
  //   numeroHabitacion:true,
  //   tiempo:30
  // }


  //****************** santo domingo prod ******************
  // urlBase: 'https://api-test.smallshi.com/',
  // urlReservas: "https://nreservas-dom.smallshi.com/",

  // ******************  prod ****************** DOIT CENTER
  // urlBase: 'https://api-prod.smallshi.com/',
  // urlReservas: 'https://nreservas-prod.smallshi.com/'

  // ****************** test ******************
  //  urlBase: 'https://api-test.smallshi.com/',
  //  urlReservas: 'https://reservas-test.smallshi.com/av/',

  // ****************** Dev ******************
  // urlBase: 'https://api-dev.smallshi.com/',
  // urlReservas: 'https://nreservascom-dev.smallshi.com'

  // ****************** api dom ************************* Esta no estoy seguro de que hace
  // urlBase: 'https://api-dom.smallshi.com/',


  // ******************  PANAMA ******************  Estan todos los paises  [dom esp emx pty ]
  // urlBase: 'https://api-pty.smallshi.com/',
  // urlReservas: 'https://nreservas-pty.smallshi.com/',

  // ****************** COLOMBIA PROD ******************  Estan todos los paises
  // urlBase: 'https://api-col.smallshi.com/',
  // urlReservas: 'https://nreservas-col.smallshi.com/',

  // ****************** pty ******************  Estan todos los paises
  urlBase: 'https://api-pty.smallshi.com/',
  urlReservas: 'https://nreservas-pty.smallshi.com/',

  options: {
    isHotel:false,
    taskUrl:'https://test-api-alfred-itto.smallshi.com/',
    inspector_id:1914,
    administrador:1925,
    numeroHabitacion:false,
    tiempo:30
  }



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
